import React from "react"

import {
	Button,
	IconButton,
	Stack,
} from "@mui/material"

import { GridColDef } from "@mui/x-data-grid"

import { Trans } from "@lingui/macro"

import { renderProgress } from "components/filledProgressBar/filledProgressBar"
import Icon from "@mdi/react"
import {
	mdiEmail,
	mdiHeartPlusOutline,
} from "@mdi/js"
import { Link } from "react-router-dom"
import { GridRenderCellParams } from "@mui/x-data-grid/models/params/gridCellParams"

export interface CompatibleAssetsColumnInterface {
	getLikes: () => string[]
	toggleLike: (id: string, isLike: boolean) => void
}


const euro = Intl.NumberFormat("it-IT", {
	style: 'currency',
	currency: 'EUR',
});


const defaultColumnDefinition: GridColDef = {
	headerName: "",
	editable: false,
	sortable: false,
	flex: 1,
	headerAlign: "left",
	align: "left",
} as GridColDef
const getTableColumns = (data: CompatibleAssetsColumnInterface): GridColDef[] => {
	return [
		{
			...defaultColumnDefinition,
			field: "brandLogo",
			headerName: "Compatibilità con",
			flex: 0.5,
			align: "center",
			renderCell: (params: { row: any }) => {
				return (
					<>
						<img src={params.row.brand.logo} width="48px" style={{ borderRadius: "50%", }} alt="" />
					</>
				)
			},
		},
		{
			...defaultColumnDefinition,
			field: "assetAddress",
			headerName: "Immobile",
			flex: 2,
			valueGetter: (params) => {
				return params.row.asset.address
			},
		},
		{
			...defaultColumnDefinition,
			field: "assetGla",
			headerName: "Dimensioni (mq)",
			valueGetter: (params) => {
				return params.row.asset.characteristics.gla
			},
		},
		{
			...defaultColumnDefinition,
			field: "price",
			headerName: "Prezzo",
			valueGetter: (params) => {
				return euro.format(params.row.asset.characteristics.price)
			},
		},
		{
			...defaultColumnDefinition,
			field: "compatibility",
			headerName: "Compatibilità",
			renderCell: (params: GridRenderCellParams) => {
				return (
					renderProgress(params.value)
				)
			}
		},
		{
			...defaultColumnDefinition,
			field: "button",
			headerName: "",
			renderCell: (params: GridRenderCellParams) => {
				const isLike = data.getLikes().find((assetId) => assetId === params.row.asset.id)
				return (
					<Stack direction="row" alignItems="center">
						{/*<IconButton*/}
						{/*	disableFocusRipple*/}
						{/*	disableRipple>*/}
						{/*	<Icon path={mdiEmail} size="22px" />*/}
						{/*</IconButton>*/}
						<IconButton disableFocusRipple
									disableRipple
									sx={{
										color:
											isLike
												?
												"secondary.main" : "inherit" ,
										backgroundColor: "transparent",
									}}
									onClick={() => data.toggleLike(params.row.asset.id, !!isLike)}
						>
							<Icon path={mdiHeartPlusOutline} size="22px" />
						</IconButton>
						<Link key="matchDetails" to={`/match/${params.row.id}`}>
							<Button
								variant="contained"
								size="small"
								disableElevation
								color="secondary"
								sx={{ ml: 2, }}
								>
								<Trans id="compatible-assets-table.view-details">
									Vedi dettagli
								</Trans>
							</Button>
						</Link>
					</Stack>
				)
			},
		},
	]
}

export default getTableColumns
